import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserDto } from 'src/core/models/shared/user.dto';
import { Observable } from 'rxjs';
import { ImportUserOutputDto } from 'src/core/models/user/import-user-output.dto';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getByUsername(username: string, userId: string): Observable<boolean> {
    const url = this.getApiUrl() + '/by-user/' + username;

    return this.http.get(url, { params: { userId: userId as any } }) as Observable<boolean>;
  }

  getByEmail(email: string, userId: string): Observable<boolean> {
    const url = this.getApiUrl() + '/by-email-address/' + email;

    return this.http.get(url, { params: { userId: userId as any } }) as Observable<boolean>;
  }

  getByPbxAgentId(pbxAgentId: string, userId: string): Observable<boolean> {
    const url = this.getApiUrl() + '/by-pbx-agent-id/' + pbxAgentId;

    return this.http.get(url, { params: { userId: userId as any } }) as Observable<boolean>;
  }

  getByDeviceId(deviceId: string, userId: string): Observable<boolean> {
    const url = this.getApiUrl() + '/by-device-id/' + deviceId;

    return this.http.get(url, { params: { userId: userId as any } }) as Observable<boolean>;
  }

  getByExternalId(externalId: string, userId: string): Observable<boolean> {
    const url = this.getApiUrl() + '/by-external-id/' + externalId;

    return this.http.get(url, { params: { userId: userId as any } }) as Observable<boolean>;
  }

  importFromFile(files: FormData): Observable<ImportUserOutputDto> {
    const url = this.getApiUrl() + '/import-from-file';
    return this.http.post(url, files) as Observable<ImportUserOutputDto>;
  }

  downloadExampleFile(): Observable<File> {
    const url = this.getApiUrl() + '/example-file';
    return this.http.get<File>(url, {
      responseType: 'blob' as 'json',
    }) as unknown as Observable<File>;
  }

  getConfirmedAiUsageDisclaimer(): Observable<boolean> {
    const url = this.getApiUrl() + '/ai-usage-disclaimer';

    return this.http.get(url) as Observable<boolean>;
  }

  setConfirmedAiUsageDisclaimer(): Observable<any> {
    const url = this.getApiUrl() + '/ai-usage-disclaimer';

    return this.http.post(url, null) as Observable<any>;
  }

  private getApiUrl(): string {
    const apiBase = environment.apis.default.url;

    return apiBase.length > 0 ? apiBase + '/' + UserDto.apiUrl : UserDto.apiUrl;
  }
}
